import { RefreshCw } from "lucide-react";
import { ApiError } from "@/lib/api";
import { Button } from "./ui/button";

export function Loading({ what }: { what: string }) {
  return (
    <p role="status" className="px-4 py-8 text-sm text-muted-foreground">
      Loading {what}…
    </p>
  );
}

/**
 * A failed read says which failure it was, because the three that happen are
 * fixed in three different places: the API is down, the session went away, or
 * this account may not read it.
 */
export function LoadFailure({ what, error, onRetry }: { what: string; error: Error; onRetry: () => void }) {
  const api = error instanceof ApiError ? error : null;
  return (
    <div role="alert" className="flex flex-col items-start gap-2 px-4 py-6 text-sm">
      <p className="font-medium text-danger">Could not load {what}.</p>
      <p className="text-muted-foreground">
        {api === null ? error.message : `${api.message} (${api.code})`}
      </p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        <RefreshCw aria-hidden="true" className="h-3.5 w-3.5" />
        Try again
      </Button>
    </div>
  );
}
